export enum EASYPLAN_ASSET_KEYS {
  LEFT_ARROW_DISABLED_ICON = 'LEFT_ARROW_DISABLED_ICON',
  LEFT_ARROW = 'LEFT_ARROW',
  RIGHT_ARROW_ICON = 'RIGHT_ARROW_ICON',
  RIGHT_ARROW_DISABLED_ICON = 'RIGHT_ARROW_DISABLED_ICON',
  ATTENTION_ICON = 'ATTENTION_ICON',
  CROSS_ICON = 'CROSS_ICON',
  TOP_IMAGE_WELCOME_ICON = 'TOP_IMAGE_WELCOME_ICON',
  TOP_IMAGE_COST_ICON = 'TOP_IMAGE_COST_ICON',
  EXIT_WARNING = 'EXIT_WARNING',
  PERKS_ICON = 'PERKS_ICON',
  ABOUT_ICON = 'ABOUT_ICON',
  PLACEHOLDER_IMG = 'PLACEHOLDER_IMG',
}

export type EasyPlanAssests = Record<EASYPLAN_ASSET_KEYS, unknown>;
